import { COOKIE_CONSENT_PRIVACY_HREF } from '../constants/cookieConsent.constants';
import { CookieConsentDescription as Description } from '../CookieConsent.styles';

const CookieConsentDescription = ({ translations }) => (
	<Description>
		{translations.description}{' '}
		<a
			href={COOKIE_CONSENT_PRIVACY_HREF}
			target="_blank"
			rel="noopener noreferrer"
		>
			{translations.readMore}
		</a>
	</Description>
);

export default CookieConsentDescription;
